import type {
  FormListFieldData,
  FormListOperation
} from "antd/es/form/FormList"
import type { FormInstance } from "antd/es/form/hooks/useForm"
import type { NamePath } from "antd/es/form/interface"

export function formListAddFocus<T>(
  add: FormListOperation["add"],
  fields: FormListFieldData[],
  form: FormInstance<T>,
  name: NamePath<T>,
  subPath?: (string | number)[]
) {
  const newIndex = fields.length
  add()

  setTimeout(() => {
    const basePath = Array.isArray(name)
      ? [...name, newIndex]
      : [name, newIndex]
    const fieldName = subPath ? [...basePath, ...subPath] : basePath

    form.focusField(fieldName)

    // form.scrollToField(fieldName, {
    //   scrollMode: "always",
    //   behavior: "smooth",
    //   block: "center",
    //   focus: true
    // })
  }, 0)
}
